export default __webpack_public_path__ + "static/media/ReactJS.c4a62e07.png";